module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/home-front-service-lvl2-75.0d27c0a6.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/home-front-service-lvl2-75.png
// module id = 3539
// module chunks = 11